"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleValidationErrors = exports.unwrapErrors = void 0;
var missing_field_exception_1 = require("../exceptions/missing-field-exception");
var invalid_field_exception_1 = require("../exceptions/invalid-field-exception");
function unwrapErrors(errors, opts) {
    var _a, _b;
    var error = errors[0];
    if (!error) {
        return null;
    }
    var primaryTarget = opts === null || opts === void 0 ? void 0 : opts.primaryTarget;
    var propertyPath = opts === null || opts === void 0 ? void 0 : opts.propertyPath;
    var context = opts === null || opts === void 0 ? void 0 : opts.context;
    var omitMessageTarget = opts === null || opts === void 0 ? void 0 : opts.omitMessageTarget;
    var target = primaryTarget ? primaryTarget : (_a = error.target) === null || _a === void 0 ? void 0 : _a.constructor.name;
    var property = propertyPath ? "".concat(propertyPath, ".").concat(error === null || error === void 0 ? void 0 : error.property) : error === null || error === void 0 ? void 0 : error.property;
    if ((_b = error.children) === null || _b === void 0 ? void 0 : _b.length) {
        return unwrapErrors(error.children, {
            primaryTarget: target,
            propertyPath: property,
            context: context,
            omitMessageTarget: omitMessageTarget,
        });
    }
    var failureReason = 'is invalid';
    var constraintKey;
    if (error.constraints) {
        constraintKey = Object.keys(error.constraints)[0];
        if (constraintKey) {
            failureReason = error.constraints[constraintKey].replace(error.property, '').trim();
        }
    }
    var message = target && !omitMessageTarget
        ? "Property ".concat(property, " of ").concat(target, " ").concat(failureReason)
        : "Property ".concat(property, " ").concat(failureReason);
    if (context) {
        var contextStr = String(context);
        try {
            contextStr = JSON.stringify(context);
        }
        catch (_c) { }
        message = "".concat(message, ". ").concat(contextStr);
    }
    return {
        error: error,
        property: property,
        message: message,
        constraint: constraintKey,
        failureReason: failureReason,
        context: context,
        target: target,
    };
}
exports.unwrapErrors = unwrapErrors;
var handleValidationErrors = function (errors, context, doNotThrow) {
    if (!errors.length) {
        return;
    }
    var unwrapped = unwrapErrors(errors, { context: context });
    if (!unwrapped) {
        return;
    }
    if (!doNotThrow) {
        if (unwrapped.constraint === 'isDefined') {
            throw new missing_field_exception_1.MissingFieldException(unwrapped.property, unwrapped.message, unwrapped.failureReason, unwrapped.constraint, unwrapped.error, unwrapped.target, unwrapped.context);
        }
        throw new invalid_field_exception_1.InvalidFieldException(unwrapped.property, unwrapped.message, unwrapped.failureReason, unwrapped.constraint, unwrapped.error, unwrapped.target, unwrapped.context);
    }
};
exports.handleValidationErrors = handleValidationErrors;
//# sourceMappingURL=handle-validation-errors.js.map